export const getFormedEltTranslation = (key: string) => `jbp-elt-${key.toLowerCase()}`
